import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { sgsstExamenes, sgsstAusentismo, getSgsstEmpleados } from '../services/api';

// Lleva el botón de acción a la fila de las sub-pestañas (Exámenes / Ausentismo).
function SaludActions({ children }) {
  const [el, setEl] = useState(null);
  useEffect(() => { setEl(document.getElementById('salud-actions')); return () => setEl(null); }, []);
  return el ? createPortal(children, el) : null;
}
import SgsstTabs from '../components/SgsstTabs';
import { S, F, Grid, Grid3, Modal, useFlash, fdate, dateVal } from '../components/sgsstUi';

const EX_TIPO = { ingreso: 'Ingreso', periodico: 'Periódico', egreso: 'Egreso', post_incapacidad: 'Post-incapacidad', reintegro: 'Reintegro' };
const EX_CONC = { apto: { l: 'Apto', c: '#10b981' }, apto_restriccion: { l: 'Apto con restricción', c: '#f59e0b' }, no_apto: { l: 'No apto', c: '#ef4444' }, aplazado: { l: 'Aplazado', c: '#94a3b8' } };
const AUS_TIPO = { enfermedad_general: 'Enf. general', accidente_trabajo: 'Accidente trabajo', enfermedad_laboral: 'Enf. laboral', licencia: 'Licencia', permiso: 'Permiso', otro: 'Otro' };
const hoy = () => new Date().toISOString().slice(0, 10);

export default function SgsstSalud() {
  const [sub, setSub] = useState('examenes');
  const [emp, setEmp] = useState([]);
  useEffect(() => { getSgsstEmpleados().then(r => setEmp(r.data)).catch(() => {}); }, []);
  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 4 }}>
          {[['examenes', 'Exámenes médicos'], ['ausentismo', 'Ausentismo']].map(([k, l]) =>
            <button key={k} onClick={() => setSub(k)} style={{ ...sub2, ...(sub === k ? sub2On : {}) }}>{l}</button>)}
        </div>
        <div id="salud-actions" style={{ display: 'flex', gap: 8 }} />
      </div>
      {sub === 'examenes' ? <Examenes emp={emp} /> : <Ausentismo emp={emp} />}
    </div>
  );
}

const sub2 = { padding: '7px 14px', borderRadius: 8, border: '1px solid #334155', background: 'transparent', color: '#94a3b8', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const sub2On = { background: '#1e293b', color: '#f1f5f9', borderColor: '#f59e0b' };

function EmpSelect({ form, setForm, emp }) {
  const pick = (id) => { const e = emp.find(x => x.id === id); setForm({ ...form, empleado_id: id, empleado_nombre: e ? e.nombre : form.empleado_nombre }); };
  return (<>
    <F l="Trabajador"><select style={S.in} value={form.empleado_id || ''} onChange={e => pick(e.target.value)}>
      <option value="">— Manual —</option>
      {emp.map(e => <option key={e.id} value={e.id}>{e.nombre} · {e.numero_documento}</option>)}
    </select></F>
    {!form.empleado_id && <F l="Nombre del trabajador"><input style={S.in} value={form.empleado_nombre} onChange={e => setForm({ ...form, empleado_nombre: e.target.value })} /></F>}
  </>);
}

function Examenes({ emp }) {
  const V = { empleado_id: '', empleado_nombre: '', tipo: 'periodico', fecha: hoy(), ips_entidad: '', concepto: 'apto', restricciones: '', recomendaciones: '', fecha_proximo: '' };
  const [lista, setLista] = useState([]); const [m, setM] = useState(null); const [msgNode, flash] = useFlash(); const [busy, setBusy] = useState(false);
  const load = () => sgsstExamenes.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const setForm = (form) => setM({ ...m, form });
  const guardar = async () => {
    if (!m.form.empleado_id && !m.form.empleado_nombre?.trim()) return flash(false, 'Indica el trabajador');
    setBusy(true); try { if (m.id) await sgsstExamenes.update(m.id, m.form); else await sgsstExamenes.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (r) => { if (!window.confirm('¿Eliminar?')) return; try { await sgsstExamenes.remove(r.id); load(); } catch (e) {} };
  return (<>
    <SaludActions><button style={S.btn} onClick={() => setM({ form: { ...V } })}>+ Nuevo examen</button></SaludActions>
    {msgNode}
    <div style={S.card}><div style={{ overflowX: 'auto' }}><table style={S.table}>
      <thead><tr>{['Fecha', 'Trabajador', 'Tipo', 'IPS', 'Concepto', 'Próximo', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
      <tbody>
        {lista.length === 0 && <tr><td colSpan={7} style={S.empty}>Sin exámenes.</td></tr>}
        {lista.map(r => { const c = EX_CONC[r.concepto] || EX_CONC.apto; return (
          <tr key={r.id}>
            <td style={S.td}>{fdate(r.fecha)}</td><td style={{ ...S.td, color: '#e2e8f0' }}>{r.empleado_nombre || '—'}</td>
            <td style={S.td}>{EX_TIPO[r.tipo] || r.tipo}</td><td style={S.td}>{r.ips_entidad || '—'}</td>
            <td style={S.td}><span style={{ ...S.badge, background: c.c + '22', color: c.c }}>{c.l}</span></td>
            <td style={S.td}>{fdate(r.fecha_proximo)}</td>
            <td style={S.td}><button style={S.link} onClick={() => setM({ id: r.id, form: { ...V, ...r, fecha: dateVal(r.fecha), fecha_proximo: dateVal(r.fecha_proximo) } })}>Editar</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(r)}>Eliminar</button></td>
          </tr>); })}
      </tbody>
    </table></div></div>
    {m && <Modal title={m.id ? 'Editar examen' : 'Nuevo examen médico'} onClose={() => setM(null)}>
      <EmpSelect form={m.form} setForm={setForm} emp={emp} />
      <Grid3>
        <F l="Tipo"><select style={S.in} value={m.form.tipo} onChange={e => setForm({ ...m.form, tipo: e.target.value })}>{Object.entries(EX_TIPO).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
        <F l="Fecha"><input type="date" style={S.in} value={m.form.fecha} onChange={e => setForm({ ...m.form, fecha: e.target.value })} /></F>
        <F l="Concepto"><select style={S.in} value={m.form.concepto} onChange={e => setForm({ ...m.form, concepto: e.target.value })}>{Object.entries(EX_CONC).map(([v, o]) => <option key={v} value={v}>{o.l}</option>)}</select></F>
      </Grid3>
      <Grid>
        <F l="IPS / entidad"><input style={S.in} value={m.form.ips_entidad} onChange={e => setForm({ ...m.form, ips_entidad: e.target.value })} /></F>
        <F l="Próximo examen"><input type="date" style={S.in} value={m.form.fecha_proximo || ''} onChange={e => setForm({ ...m.form, fecha_proximo: e.target.value })} /></F>
      </Grid>
      <F l="Restricciones"><input style={S.in} value={m.form.restricciones} onChange={e => setForm({ ...m.form, restricciones: e.target.value })} /></F>
      <F l="Recomendaciones"><input style={S.in} value={m.form.recomendaciones} onChange={e => setForm({ ...m.form, recomendaciones: e.target.value })} /></F>
      <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
    </Modal>}
  </>);
}

function Ausentismo({ emp }) {
  const V = { empleado_id: '', empleado_nombre: '', tipo: 'enfermedad_general', fecha_inicio: hoy(), fecha_fin: '', dias: 1, diagnostico: '', cie10: '', origen: 'comun', observacion: '' };
  const [lista, setLista] = useState([]); const [m, setM] = useState(null); const [msgNode, flash] = useFlash(); const [busy, setBusy] = useState(false);
  const load = () => sgsstAusentismo.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const setForm = (form) => setM({ ...m, form });
  const guardar = async () => {
    if (!m.form.empleado_id && !m.form.empleado_nombre?.trim()) return flash(false, 'Indica el trabajador');
    setBusy(true); try { if (m.id) await sgsstAusentismo.update(m.id, m.form); else await sgsstAusentismo.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (r) => { if (!window.confirm('¿Eliminar?')) return; try { await sgsstAusentismo.remove(r.id); load(); } catch (e) {} };
  return (<>
    <SaludActions><button style={S.btn} onClick={() => setM({ form: { ...V } })}>+ Registrar ausencia</button></SaludActions>
    {msgNode}
    <div style={S.card}><div style={{ overflowX: 'auto' }}><table style={S.table}>
      <thead><tr>{['Trabajador', 'Tipo', 'Origen', 'Inicio', 'Fin', 'Días', 'Diagnóstico', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
      <tbody>
        {lista.length === 0 && <tr><td colSpan={8} style={S.empty}>Sin registros.</td></tr>}
        {lista.map(r => (
          <tr key={r.id}>
            <td style={{ ...S.td, color: '#e2e8f0' }}>{r.empleado_nombre || '—'}</td><td style={S.td}>{AUS_TIPO[r.tipo] || r.tipo}</td>
            <td style={S.td}><span style={{ ...S.badge, background: r.origen === 'laboral' ? '#ef444422' : '#94a3b822', color: r.origen === 'laboral' ? '#ef4444' : '#94a3b8' }}>{r.origen}</span></td>
            <td style={S.td}>{fdate(r.fecha_inicio)}</td><td style={S.td}>{fdate(r.fecha_fin)}</td>
            <td style={{ ...S.td, textAlign: 'center', fontWeight: 700 }}>{r.dias}</td><td style={S.td}>{r.diagnostico || '—'}</td>
            <td style={S.td}><button style={S.link} onClick={() => setM({ id: r.id, form: { ...V, ...r, fecha_inicio: dateVal(r.fecha_inicio), fecha_fin: dateVal(r.fecha_fin) } })}>Editar</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(r)}>Eliminar</button></td>
          </tr>
        ))}
      </tbody>
    </table></div></div>
    {m && <Modal title={m.id ? 'Editar ausencia' : 'Registrar ausencia'} onClose={() => setM(null)}>
      <EmpSelect form={m.form} setForm={setForm} emp={emp} />
      <Grid>
        <F l="Tipo"><select style={S.in} value={m.form.tipo} onChange={e => setForm({ ...m.form, tipo: e.target.value })}>{Object.entries(AUS_TIPO).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
        <F l="Origen"><select style={S.in} value={m.form.origen} onChange={e => setForm({ ...m.form, origen: e.target.value })}>{['comun', 'laboral'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
      </Grid>
      <Grid3>
        <F l="Inicio"><input type="date" style={S.in} value={m.form.fecha_inicio} onChange={e => setForm({ ...m.form, fecha_inicio: e.target.value })} /></F>
        <F l="Fin"><input type="date" style={S.in} value={m.form.fecha_fin || ''} onChange={e => setForm({ ...m.form, fecha_fin: e.target.value })} /></F>
        <F l="Días"><input type="number" style={S.in} value={m.form.dias} onChange={e => setForm({ ...m.form, dias: +e.target.value })} /></F>
      </Grid3>
      <Grid>
        <F l="Diagnóstico"><input style={S.in} value={m.form.diagnostico} onChange={e => setForm({ ...m.form, diagnostico: e.target.value })} /></F>
        <F l="CIE-10"><input style={S.in} value={m.form.cie10} onChange={e => setForm({ ...m.form, cie10: e.target.value })} /></F>
      </Grid>
      <F l="Observación"><input style={S.in} value={m.form.observacion} onChange={e => setForm({ ...m.form, observacion: e.target.value })} /></F>
      <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
    </Modal>}
  </>);
}
